import React, { MouseEvent, ReactElement, useCallback } from 'react';
import { useRouterPush } from 'b2b-apps/shop/routes/hooks';
import { openLink } from 'b2b-apps/shop/routes/utils/url';
import { EnhancedComponentProps, EnhancedComponentType, WrappedComponentType } from './';

export const withContainer = (Component: WrappedComponentType): EnhancedComponentType => {
  const WithContainer = (props: EnhancedComponentProps): ReactElement => {
    const push = useRouterPush();

    const handleClick = useCallback((url: string, e?: MouseEvent<any>) => {
      e && e.preventDefault();
      openLink(url, push, e);
    }, [push]);

    return <Component {...props} handleClick={handleClick} />;
  };

  return WithContainer;
};
